module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "transmission-personalized-setting"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    传单个性化校验\n    "), _c('span', {
    staticClass: "transmission-applicable-personnel-setting"
  }, [_c('span', [_vm._v("适用人员：")]), _vm._v(" "), (_vm.applicablePersonnel) ? _c('el-radio-group', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.applicablePersonnel.value),
      callback: function($$v) {
        _vm.$set(_vm.applicablePersonnel, "value", $$v)
      },
      expression: "applicablePersonnel.value"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("全部人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("指定名单")])], 1) : _vm._e(), _vm._v(" "), (_vm.applicablePersonnel && _vm.applicablePersonnel.value === 2) ? _c('span', [_c('el-select', {
    attrs: {
      "placeholder": "请选择名单",
      "size": "mini",
      "clearable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.applicablePersonnel.personValue),
      callback: function($$v) {
        _vm.$set(_vm.applicablePersonnel, "personValue", $$v)
      },
      expression: "applicablePersonnel.personValue"
    }
  }, _vm._l((_vm.applicablePersonnel.configExtends[0] && _vm.applicablePersonnel.configExtends[0].options), function(item) {
    return _c('el-option', {
      key: item.business,
      attrs: {
        "label": item.business,
        "value": item.business
      }
    })
  }), 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('div', {
    staticClass: "config-row"
  }, [_c('div', {
    staticClass: "config-header"
  }, [_c('span', [_vm._v("开启【订单重复风险检测】")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": "true",
      "inactive-value": "false"
    },
    model: {
      value: (_vm.orderDuplicationRiskCheckConfig.value),
      callback: function($$v) {
        _vm.$set(_vm.orderDuplicationRiskCheckConfig, "value", $$v)
      },
      expression: "orderDuplicationRiskCheckConfig.value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "config-description"
  }, [_vm._v("\n        说明:针对衣柜订单，按照订单板件PID与已下单订单对比，判断是否存在重复下单风险。若系统判断有重复风险，会在订单传单时做出提醒。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "config-row"
  }, [_c('div', {
    staticClass: "config-header"
  }, [_c('span', [_vm._v("开启【订单尺寸超长超宽检测】")]), _vm._v(" "), _c('span', {
    staticClass: "size-inputs"
  }, [_c('span', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("电梯可容纳长")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.getSizeValue('length'),
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.orderSizeCheckConfig && _vm.orderSizeCheckConfig.value === 'false',
      "min": 0,
      "precision": 2,
      "controls": false
    },
    on: {
      "input": function($event) {
        return _vm.setSizeValue('length', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-unit"
  }, [_vm._v("m")])], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("宽")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.getSizeValue('width'),
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.orderSizeCheckConfig && _vm.orderSizeCheckConfig.value === 'false',
      "min": 0,
      "precision": 2,
      "controls": false
    },
    on: {
      "input": function($event) {
        return _vm.setSizeValue('width', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-unit"
  }, [_vm._v("m")])], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("深")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.getSizeValue('height'),
      "placeholder": "请输入",
      "size": "mini",
      "disabled": _vm.orderSizeCheckConfig && _vm.orderSizeCheckConfig.value === 'false',
      "min": 0,
      "precision": 2,
      "controls": false
    },
    on: {
      "input": function($event) {
        return _vm.setSizeValue('height', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-unit"
  }, [_vm._v("m")])], 1)]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": "true",
      "inactive-value": "false"
    },
    model: {
      value: (_vm.orderSizeCheckConfig.value),
      callback: function($$v) {
        _vm.$set(_vm.orderSizeCheckConfig, "value", $$v)
      },
      expression: "orderSizeCheckConfig.value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "config-description"
  }, [_vm._v("\n        说明:针对订单尺寸超长超宽会产生额外搬运等费用的情况，系统将订单的长宽高尺寸与商场设定的常规尺寸对比，若出现超长超宽风险，会在订单传单时做提醒。\n      ")])]), _vm._v(" "), _vm._l((_vm.configFormItemList), function(item) {
    return _c('div', {
      key: item.ruleId,
      staticClass: "config-row"
    }, [_c('div', {
      staticClass: "config-header"
    }, [_c('span', [_vm._v(_vm._s(item.formDisplayTitle))]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-text": "是",
        "inactive-text": "否",
        "active-value": "true",
        "inactive-value": "false"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "config-description"
    }, [_vm._v("\n        " + _vm._s(item.formDisplayContent) + "\n      ")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dec1a0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/transmissionPersonalizedSetting.vue
// module id = 2409
// module chunks = 68